import { routes } from '../site';

/**
 * Blog sayfalarının sabit metinleri (/blog, /blog/kategori/{kısa ad}, /blog/{kısa ad}, /blog/onizleme/{belirteç}).
 * Yazılar ve kategoriler admin panelinden gelir; burada yalnız sayfa iskeletinin metni var.
 */
export const blogPage = {
  href: routes.blog,
  hero: {
    eyebrow: 'Blog',
    title: 'E-ticarette kârlı büyümenin rehberi',
    lead: 'Pazaryeri komisyonlarından kampanya kârlılığına, stok yönetiminden finansal mutabakata; e-ticaret operasyonunu kârlı yönetmek için pratik yazılar.',
  },
  categoriesLabel: 'Kategoriler',
  /** Kategori sayfasının başlık üstü etiketi. */
  categoryEyebrow: 'Kategori',
  allLabel: 'Tüm yazılar',
  teamAuthor: 'ZHesap Ekibi',
  readingTime: (minutes: number) => `${minutes} dk okuma`,
  /** Sol kenar çubuğu. */
  sidebar: {
    searchLabel: 'Blog’da ara',
    searchPlaceholder: 'Blog’da ara…',
    searchButton: 'Ara',
    recentTitle: 'Son yazılar',
    categoriesTitle: 'Kategoriler',
  },
  /** Üstteki öne çıkan kart ve kartlardaki düğme. */
  featuredLabel: 'Öne çıkan',
  readMore: 'Devamını oku',
  /** Aktif süzgeçler: arama ve etiket. */
  filters: {
    results: (count: number, term: string) => `“${term}” için ${count} yazı`,
    tagResults: (count: number, tag: string) => `#${tag} etiketli ${count} yazı`,
    clear: 'Süzgeci kaldır',
    noResults: 'Aramanıza uyan yazı bulunamadı.',
    noResultsHint: 'Farklı bir kelime deneyin ya da kategorilere göz atın.',
  },
  pagination: {
    label: 'Sayfalar',
    previous: 'Önceki',
    next: 'Sonraki',
  },
  empty: {
    title: 'Yazılar çok yakında burada',
    desc: 'İlk yazılarımızı hazırlıyoruz. Bu arada ZHesap’ı kendi verilerinizle görmek için demo talep edebilirsiniz.',
    cta: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
  },
  emptyPage: {
    title: 'Bu sayfada yazı yok',
    cta: { label: 'İlk sayfaya dön', href: routes.blog },
  },
  unavailable: {
    title: 'Yazılar şu an yüklenemedi',
    desc: 'Bağlantıda geçici bir sorun var. Birazdan yeniden deneyin.',
    retry: 'Yeniden dene',
  },
  post: {
    backToList: 'Tüm yazılar',
    /** Yazının üstündeki geri dönüş bağlantısı. */
    back: 'Tüm yazılara dön',
    authorLabel: 'Yazar',
    authorPageLink: 'Yazarın hikâyesi',
    updatedLabel: 'Güncellendi',
    tocTitle: 'İçindekiler',
    tagsLabel: 'Etiketler',
    shareTitle: 'Paylaş',
    shareCardTitle: 'Bu yazıyı paylaş',
    shareLinkedIn: 'LinkedIn’de paylaş',
    shareX: 'X’te paylaş',
    copyLink: 'Bağlantıyı kopyala',
    copied: 'Bağlantı kopyalandı',
    related: 'Diğer yazılar',
  },
  /** Admin'den üretilen süreli bağlantıyla taslağın sitedeki görünümü. */
  preview: {
    title: 'Taslak önizleme',
    banner: 'Taslak önizleme: bu bağlantı 2 saat geçerlidir ve yalnız sizinle paylaşılan kişiler görür. Yazı yayına girene kadar ziyaretçiler göremez.',
    invalidTitle: 'Önizleme bağlantısı geçersiz ya da süresi dolmuş',
    invalidDesc: 'Admin panelinden yazıyı açıp “Önizle” ile yeni bir bağlantı üretin.',
  },
  cta: {
    title: 'Kârını gerçekten görmeye hazır mısın?',
    desc: 'ZHesap pazaryeri ve e-ticaret verilerini tek panelde birleştirir; her siparişin net kârını gösterir.',
    button: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
  },
} as const;
